module.exports = __webpack_public_path__ + "static/Vabysmo_logo_FR-a19c479a9fbac69df2564f9382f2f1e0.svg";